import { i18n } from "../main";
import merge from 'lodash/merge';
export const mergeLocaleMessages = (newMsgs, mergeFields) => {
    // newMsgs example: { en: { home: { text: 'New title!' } } }
    // custom lang message that has empty value, will revert to default message.
    // For example if the "Title" field has an empty value, the key will be removed and thus the default value (in locales/xx.json) will be shown
    newMsgs = removeEmpty(newMsgs);
    Object.keys(newMsgs).forEach((locale) => {
        if (mergeFields) {
            const newMsgStr = JSON.stringify(newMsgs)
                .replaceAll('[[COMPANY_NAME]]', mergeFields.companyName);
            newMsgs = JSON.parse(newMsgStr);
        }
        let messages = merge(i18n.global.getLocaleMessage(locale), newMsgs[locale]);
        i18n.global.setLocaleMessage(locale, messages);
    });
};
export const t = (key, obj = null) => {
    // @ts-ignore
    return i18n.global.t(key, obj);
};
/**
 * Deletes all object properties that have empty value (recursively)
 * @param obj
 */
function removeEmpty(obj) {
    return Object.keys(obj)
        .filter(function (k) {
        return obj[k] != '';
    })
        .reduce(function (acc, k) {
        acc[k] = typeof obj[k] === "object" ? removeEmpty(obj[k]) : obj[k];
        return acc;
    }, {});
}
// function replaceValuesInRecursiveObject(obj) {
//     let keyValue = ''
//     if (typeof obj === 'object') {
//         // iterating over the object using for..in
//         for (var keys in obj) {
//             //checking if the current value is an object itself
//             if (typeof obj[keys] === 'object' || typeof obj[keys] === 'function') {
//                 // if so then again calling the same function
//                 changeValue(obj[keys])
//             } else {
//                 // else getting the value and replacing single { with {{ and so on
//                 if(typeof obj[keys] === 'string') {
//                     keyValue = obj[keys].replaceAll('[', '[[').replace(']', ']]');
//                     if(keyValue.includes('[')) {
//                         console.log(keyValue)
//                     }
//                     obj[keys] = keyValue;
//                 }
//             }
//         }
//     }
//     return obj;
// }
